"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MIN_PASSWORD_LENGTH } from "@/lib/auth/login-flow";

/** Set password form for imported unencrypted backups */
export function SetPasswordContent(t0) {
  const $ = _c(28);
  const {
    confirmPassword,
    loading,
    newPassword,
    onCancel,
    onConfirmPasswordChange,
    onNewPasswordChange,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col items-center gap-2 text-center"><h2 className="font-bold text-xl">Set Password</h2><p className="text-muted-foreground text-sm">Create a password to encrypt your imported wallet for secure storage.</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Label htmlFor="new-password">Password</Label>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onNewPasswordChange) {
    t3 = e => onNewPasswordChange(e.target.value);
    $[2] = onNewPasswordChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== loading || $[5] !== newPassword || $[6] !== t3) {
    t4 = <div className="grid gap-2">{t2}<Input disabled={loading} id="new-password" minLength={MIN_PASSWORD_LENGTH} onChange={t3} placeholder="Enter a strong password" required={true} type="password" value={newPassword} /></div>;
    $[4] = loading;
    $[5] = newPassword;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Label htmlFor="confirm-password">Confirm Password</Label>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onConfirmPasswordChange) {
    t6 = e_0 => onConfirmPasswordChange(e_0.target.value);
    $[9] = onConfirmPasswordChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== confirmPassword || $[12] !== loading || $[13] !== t6) {
    t7 = <div className="grid gap-2">{t5}<Input disabled={loading} id="confirm-password" minLength={MIN_PASSWORD_LENGTH} onChange={t6} placeholder="Confirm your password" required={true} type="password" value={confirmPassword} /></div>;
    $[11] = confirmPassword;
    $[12] = loading;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = loading || !newPassword || !confirmPassword;
  const t9 = loading ? "Saving..." : "Save Wallet";
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <Button className="w-full" disabled={t8} type="submit">{t9}</Button>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== loading || $[19] !== onCancel) {
    t11 = <Button className="w-full" disabled={loading} onClick={onCancel} type="button" variant="outline">Cancel</Button>;
    $[18] = loading;
    $[19] = onCancel;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Alert><AlertDescription><strong>Important:</strong> This password cannot be recovered. If you forget it, you'll need to use your original backup file to restore access.</AlertDescription></Alert>;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== onSubmit || $[23] !== t10 || $[24] !== t11 || $[25] !== t4 || $[26] !== t7) {
    t13 = <>{t1}<form className="flex flex-col gap-6" onSubmit={onSubmit}>{t4}{t7}{t10}{t11}{t12}</form></>;
    $[22] = onSubmit;
    $[23] = t10;
    $[24] = t11;
    $[25] = t4;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}